import React, {MouseEvent, ReactElement, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {DbUserService} from "../../../services/db/dbUserService";
import {ResponseResultCode} from "../../../model/response-api";
import moment from "moment";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

export default function DbRlibr(props: Readonly<DashboardModuleProps>) {
  const [list, setList] = useState<ReactElement[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    DbUserService.getInstance().fetchRlibr().then(response => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        if (response.data && response.data.length > 0) {
          setList(response.data.map((f, i) => templateNoticeBox(f, i)))
        }
      }
    })
  }, []);

  function templateNoticeBox(data: any, index: number) {
    const today = moment().format('YYYY-MM-DD');
    const regDt = moment(data.regDate).format('YYYY-MM-DD');
    return (
      <li key={`${data.emksRlibrCd}-${data.rlibrId}`}>
        <span>
          {today === regDt && (<strong className="new">N</strong>)}
          {data.titlNm}
          <Link to="#" onClick={(e) => handleClickLi(e, data)}></Link>
        </span>
        <span>{moment(data.regDate).format('YYYY-MM-DD')}</span>
      </li>
    )
  }

  function handleClickLi(e: MouseEvent<HTMLAnchorElement>, data: any) {
    e.preventDefault();
    navigate(`/rp/rlibrDetail/${data.emksRlibrCd}/${data.rlibrId}`, {state: data});
  }

  return (
    <DashboardCard
      title="자료실"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/rp/rlibr/1"
      dashboardConfig={props.dashboardConfig}
    >
      <div className="notice-wrap">
        <ul className="notice">
          {(list && list.length > 0) && list.map((item: any) => item)}
        </ul>
      </div>
    </DashboardCard>
  );
}